import {Component, Input, OnDestroy} from "@angular/core";
import {DocumentService} from "../../services/document.service";
import {WatchService} from "../../services/watch.service";
import {ModalService} from "../../services/modal.service";
import {BusService} from "../../services/bus.service";
import {IDocument} from "../../interfaces/document.definition";
import {CollectionParams} from "../../helpers/params/collection-params";
import {E_ENDPOINTS} from "../../helpers/params/loader-params";
import {Subject} from "rxjs/Subject";
import {isUndefined} from "util";


@Component({
  selector: "nv-doc-controls",
  templateUrl: "./nv-doc-controls.component.html"
})


export class NvDocControlsComponent implements OnDestroy{

  document: any;
  hasChanges: boolean = false;
  private _endpointId:E_ENDPOINTS;

  @Input() showDelete: boolean = true;
  @Input() onDeleteMessage: string = "";
  @Input() set endpointId(val:E_ENDPOINTS) {
    this._endpointId = val;
  };

  private unsubscribe: Subject<void> = new Subject<void>();

  constructor(private documentService: DocumentService,
              private busService: BusService,
              private watchService: WatchService,
              private modalService: ModalService) {
    this.busService.onDocumentUpdated
      .takeUntil(this.unsubscribe)
      .subscribe(e => this.document = e.document);

    this.watchService.docChanged()
      .takeUntil(this.unsubscribe)
      .subscribe(hasChanges => {
        this.hasChanges = hasChanges;
      });
  }


  onJsonClick() {
    this.modalService.showJson(this.document);
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }


  onRemoveClick() {
    this.watchService.notify();
    if (this.onDeleteMessage == "") {
      this.modalService.showConfirm("Уверен?", this.onRemoveConfirmed.bind(this));
    }
    else {
      this.modalService.showMessage(this.onDeleteMessage);
    }
    //this.documentService.remove(this._endpointId);
  }

  onSaveClick() {
    if (!isUndefined(this.document.gameEventsComponent) && this.document.gameEventsComponent.length == 0) {
      this.modalService.showConfirm("Пустой gameEventsComponent", this.onSaveConfirmed.bind(this));
    }
    else {
      this.onSaveConfirmed();
    }
  }

  onResetClick() {
    this.documentService.reset();
  }

  private onRemoveConfirmed() {
    this.documentService.remove(this._endpointId);
  }

  private  onSaveConfirmed() {
    this.documentService.save(this._endpointId);
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-doc-controls/nv-doc-controls.component.ts